export const ZONA_HORARIA_UTC_4 = 4;